import { EnumTypeValue } from "@/shared/types";

export const VSM_QUERY_KEY = "vsm";

export const VsmStatus = {
    DEFINITIEF: "Definitief",
    TOEGEDEELD: "Toegedeeld",
    GESTOPt: "Gestopt",
} as const;

export type VsmStatus = EnumTypeValue<typeof VsmStatus>;
